import React, {useEffect, useState} from "react"
import {CardMedia} from "@mui/material";
import {CmVideo, RichText} from "../../../../packages/graphql-layer/src";
import useWindowSize from "../../../utility/useWindowSize";
import CCOPlainText from "../../fundamentals/CCOPlainText";
import CCOComponentWrapper from "../../fundamentals/CCOComponentWrapper";
import Script from "next/script";
import {Box} from "@mui/system";
import CCOContainer from "../../fundamentals/CCOContainer";
import {getUniqueKey} from "../../../utility/componentUtil";

export interface Props {
    video?: CmVideo
    youtubeUrl?: string
    teaserText?: RichText
    noContainer?: boolean
    customStyle?: any
    layoutSettings?: any
}

function C041Video(props: Props) {
    const {greaterThanWindowMedium} = useWindowSize();
    const url = props.youtubeUrl ? props.youtubeUrl : props.video?.dataUrl!
    const YOUTUBE_SCRIPT = "https://www.youtube.com/iframe_api";

    const [currentOrigin, setCurrentOrigin] = useState<string | undefined>(undefined);
    const uuids = getUniqueKey();

    const wrapperStyle = {
        position: 'relative',
        aspectRatio: '16/9',
    }

    const videoCartStyle = {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        boxSizing: 'content-box',
        padding: 0,
        borderStyle: "none",
    }

    const caption: JSX.Element = props.video?.detailText ?
        <Box marginTop={6}><CCOPlainText textAsTree={props.video?.detailText?.textAsTree}
                                         variant='subtitle2'/></Box> : <></>

    useEffect(() => {
        setCurrentOrigin(window.location.origin);
    }, []);

    useEffect(() => {
    }, [currentOrigin]);

    function getYoutubeUrl(url: string) {
        const parsedUrl = new URL(url);
        const searchParams = parsedUrl.searchParams;

        // Remove all parameters except videoId
        searchParams.forEach((value, key) => {
            if (key !== 'v') {
                searchParams.delete(key);
            }
        });

        url = `${parsedUrl.origin}${parsedUrl.pathname}${parsedUrl.search}`;
        const origin = `?showinfo=0&enablejsapi=1&origin=${currentOrigin}`
        if (url && url.startsWith("https://www.youtube.com/embed/")) {
            return url + origin
        } else if (url && url.startsWith("https://www.youtube.com/watch?v=") || url.startsWith("https://www.youtube.de/watch?v=")) {
            return 'https://www.youtube.com/embed/' + url.substring(url.indexOf("?v=") + 3, url.length) + origin
        } else if (url.startsWith("https://youtu.be")) {
            return 'https://www.youtube.com/embed/' + url.substring(url.indexOf("be/") + 3, url.length) + origin
        } else {
            return ''
        }
    }

    const cardMedia = () => {
        return <React.Fragment>
            <Box id={props.video?.id} sx={wrapperStyle}>
                <CardMedia sx={videoCartStyle}
                           component='iframe'
                           data-testid='iframe'
                           id='player'
                           datatype='text/html'
                           allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen'
                           src={getYoutubeUrl(url)}/>
            </Box>
            {caption}
        </React.Fragment>
    }

    if (url && currentOrigin) {
        return props.noContainer ? <Box sx={{marginBottom: '24px'}}>
                <Script type="application/javascript" src={YOUTUBE_SCRIPT}/>
                {cardMedia()}
            </Box> :
            <CCOComponentWrapper noBottomMargin={props.layoutSettings?.noBottomMargin && greaterThanWindowMedium} key={uuids[0]} customStyle={props.customStyle}>
                <CCOContainer>
                    <Script type="application/javascript"
                            src={YOUTUBE_SCRIPT}
                    />
                    {cardMedia()}
                </CCOContainer>
            </CCOComponentWrapper>
    } else {
        return <React.Fragment key={uuids[0]}/>
    }
}

export default C041Video